module.exports = __webpack_public_path__ + "static/img/叉车.91cd781.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type1-3-model/叉车.png
// module id = zpyy
// module chunks = 0